//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            searchText: ""
        }
    },
    props: {
        focus: {
            default: "false"
        }
    },
    methods: {
        onSubmit() {
            if (!this.searchText) return;
            this.$router.push({
                name: 'search',
                params: {
                    keyworld: this.searchText
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchInput/SearchInput.vue